module.exports = __webpack_public_path__ + "static/stores-payment-a3b159360e2474813a58bcdd827eabe6.png";